import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { INDUSTRY_REPORT_CATEGORY } from 'src/app/shared/constants/common-constants';

@Component({
  selector: 'app-industry-report-suggestion-card',
  templateUrl: './industry-report-suggestion-card.component.html',
  styleUrls: ['./industry-report-suggestion-card.component.scss'],
})
export class IndustryReportSuggestionCardComponent implements OnInit {
  @Input() report;

  industryReportCategory = INDUSTRY_REPORT_CATEGORY;
  constructor(private router: Router) {}

  ngOnInit(): void {
  }

  getLabelByCode(code: string): string {
    const category = this.industryReportCategory.find(
      (item) => item.code === code
    );
    return category ? category.label : 'Unknown';
  }

  navigateToDetailsPage(){
    this.router.navigate([`reports/details/${this.report.report_url}`])
  }

  getTrimValue(title,limit){
    if (title.length <= limit) return title;
    return title.slice(0, limit) + '...'
  }
}
